<template>
  <div class="orderInternetDetails">
    <TableToolTemp :toolListProps="{ toolTitle: '订单详情' }">
      <template #tips>
        <div class="orderStatus">
          <span :class="'status' + orderDetails.status">{{ orderDetails.statusDesc }}</span>
        </div>
      </template>
    </TableToolTemp>
    <div class="orderDetailsWrap">
      <div
        class="orderDetailsItem"
        v-for="item in baseOptions.filter(inner => orderDetails[inner.prop])"
        :key="item.prop"
      >
        <span>{{ item.label }}</span>
        <span v-if="item.formatter === 'dic'">{{ orderDetails[item.prop] | getDicItemName(item.dic) }}</span>
        <span v-else-if="item.formatter === 'price'">{{ orderDetails[item.prop] | toFixed }}元</span>
        <span v-else-if="item.formatter === 'link'" class="link">{{ orderDetails[item.prop] }}</span>
        <span v-else>{{ orderDetails[item.prop] }}</span>
      </div>
      <h4>互联网保险信息</h4>
      <div
        class="orderDetailsItem"
        v-for="item in internetOptions.filter(inner => orderDetails[inner.prop])"
        :key="item.prop + '1'"
      >
        <span>{{ item.label }}</span>
        <span v-if="item.formatter === 'dic'">{{ orderDetails[item.prop] | getDicItemName(item.dic) }}</span>
        <span v-else-if="item.formatter === 'price'">{{ orderDetails[item.prop] | toFixed }}元</span>
        <span v-else-if="item.formatter === 'link'" class="link" @click="handleLink(item.prop)">
          {{ orderDetails[item.prop] }}
        </span>
        <span v-else>{{ orderDetails[item.prop] }}</span>
      </div>
      <div class="btngroup">
        <el-button type="primary" @click="goback">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins';
import { internetorderDetail, OnlineProductOrderDetails } from '@/api/userCenter';

export default {
  components: { TableToolTemp, Table },
  mixins: [myMixin],
  data() {
    return {
      dicArr: ['net.payType'],
      orderDetails: {},
      baseOptions: [
        { label: '订单号', prop: 'orderCode' },
        { label: '类型', prop: 'orderType' },
        { label: '商品名称', prop: 'packageName' },
        { label: '生成时间', prop: 'createTime' },
        { label: '价格', prop: 'enquiryPremium', formatter: 'price' },
        { label: '状态', prop: 'statusDesc' },
        { label: '支付方式', prop: 'payType', formatter: 'dic', dic: 'net.payType' },
        { label: '支付时间', prop: 'payTime' },
        { label: '支付流水', prop: 'payNo' },
        { label: '退款时间', prop: 'refundTime' },
        { label: '退款流水', prop: 'refundNo' },
      ],
      internetOptions: [
        { label: '保单号', prop: 'policyCode' },
        { label: '产品名称', prop: 'packageName', formatter: 'link' },
        { label: '保险期间', prop: 'effectiveDate' },
        { label: '首期保费', prop: 'firstYearPremium', formatter: 'price' },
        { label: '投保人', prop: 'proposerName' },
        { label: '被保人', prop: 'insuredsName' },
        { label: '受益人', prop: 'benefitName' },
      ],
    };
  },
  methods: {
    init() {
      const { orderId } = this.$route.query;
      if (orderId) {
        internetorderDetail({ id: orderId }).then(res => {
          if (res) {
            res.orderType = '购买保险（互联网）';
            res.effectiveDate = `${res.effectiveDate} 至 ${res.effectiveDateEnd}`;
            res.proposerName = res.proposer.name;
            res.insuredsName = res.insureds[0].name;
            res.benefitName = res.benefit[0].isLegalBeneficiary == 1 ? '法定受益人' : '';
            this.orderDetails = res;
          }
        });
      }
    },
    handleLink(prop) {
      if (prop === 'packageName') {
        OnlineProductOrderDetails({ id: this.orderDetails.id }).then(res => {
          if (res) {
            const { recommendId, productType, consultantProductId } = res;
            this.$router.push({ name: 'recommendDetails', query: { recommendId, productType, consultantProductId } });
          }
        });
      }
    },
    goback() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.orderInternetDetails {
  h4 {
    margin-top: 10px;
    padding: 25px 0 10px;
    color: var(--primary);
    border-top: 1px dashed #dcdce1;
  }
  .orderDetailsItem {
    display: flex;
    padding: 15px 0;
    color: #555;
    > span:first-of-type {
      flex: 0 0 100px;
      font-weight: bold;
      color: #382e2b;
      &::after {
        content: '：';
      }
    }
  }
  .link {
    color: var(--primary);
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      opacity: 0.6;
    }
  }
  .btngroup {
    margin-top: 25px;
    .el-button {
      width: 110px;
    }
  }
}
.orderStatus {
  display: inline-block;
  span {
    display: inline-block;
    height: 18px;
    padding: 0 5px;
    font-size: 10px;
    font-weight: 500;
    line-height: 18px;
    color: #5788bb;
    border: 1px solid #5788bb;
    border-radius: 1px;
    text-align: center;
    &.status7 {
      color: #e27c00;
      border: 1px solid #e27c00;
    }
    &.status3 {
      color: #5788bb;
      border: 1px solid #5788bb;
    }
    &.status8 {
      color: #3f937c;
      border: 1px solid #3f937c;
    }
    &.status10 {
      color: #aaaaaf;
      border: 1px solid #aaaaaf;
    }
  }
}
</style>
